import { Injectable } from '@angular/core';
import { ConverterService, Occ, PRODUCT_NORMALIZER } from '@spartacus/core';
import { OrderEntry } from '@spartacus/cart/base/root';

@Injectable({
    providedIn: 'root',
})
export class SikoOccUtils {

    constructor(
        private readonly converter: ConverterService,
    ) {}

    convertOrderGroup(orderGroup: any, orderCode?: string): any {
        const convertedGroup = {
            ...orderGroup,
            entries: [],
        };

        if (orderGroup.entries) {
            for (const entry of orderGroup.entries) {
                const convertedEntry: OrderEntry = this.convertOrderEntry(
                    entry,
                    orderCode,
                );

                convertedGroup.entries.push(convertedEntry);
            }
        }

        return convertedGroup;
    }

    private convertOrderEntry(
        source?: Occ.OrderEntry,
        code?: string,
    ): OrderEntry {
        return {
            ...source,
            product: this.converter.convert(source?.product, PRODUCT_NORMALIZER),
            orderCode: code,
        };
    }

}
